import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import DocumentPreviewForm from './DocumentPreviewForm';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { forwardRef, useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentPreviewPopover = /*#__PURE__*/forwardRef(({
  previewTitle,
  description,
  setPreviewTitle,
  setDescription,
  updatePreview
}, ref) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = useCallback(e => {
    setOpen(e.target.value);
  }, [setOpen]);
  const handleCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const toggleOpen = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);
  const handleConfirm = useCallback(({
    title,
    desc
  }) => {
    setPreviewTitle(title);
    setDescription(desc);
    updatePreview({
      title,
      desc
    });
    setOpen(false);
  }, [setPreviewTitle, setDescription, updatePreview]);
  return /*#__PURE__*/_jsx(UIPopover, {
    open: open,
    onOpenChange: handleOpenChange,
    content: /*#__PURE__*/_jsx(DocumentPreviewForm, {
      previewTitle: previewTitle,
      previewDescription: description,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      ref: ref
    }),
    closeOnOutsideClick: true,
    placement: "top",
    animateOnToggle: false,
    children: /*#__PURE__*/_jsx("div", {
      className: "m-all-2",
      style: {
        position: 'absolute',
        bottom: '0',
        right: '0'
      },
      children: /*#__PURE__*/_jsx(UIButton, {
        size: "small",
        onClick: toggleOpen,
        "data-test-id": "document-link-preview-edit-button",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "edit"
        })
      })
    })
  });
});
export default DocumentPreviewPopover;